import React from 'react'

export const NotFoundPage = () =>  {
    return (
        <div className="container">
            <div className="p-2 pt-5 pb-5">
                <h1>Pagina no encontrada </h1>
            </div>
        </div>
    )
}
